export const intervals = {
  smsCountdownInMilliseconds: 1000,
};

export const timeouts = {
  authInMilliseconds: 3000,
  initialSmsTimeoutInSeconds: 30,
  logoutInMilliseconds: 3000,
};
